import { render, staticRenderFns } from "./cursos-detalles-resumen-preguntas.vue?vue&type=template&id=2c5b5bf7&scoped=true&"
import script from "./cursos-detalles-resumen-preguntas.vue?vue&type=script&lang=ts&"
export * from "./cursos-detalles-resumen-preguntas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5b5bf7",
  null
  
)

export default component.exports